import React from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  CircularProgress,
  Typography,
} from "@mui/material";
import { InsertDriveFile, Folder } from "@mui/icons-material";

const SearchResults = ({ results, loading, onResultClick, sx }) => {
  const commonPaperSx = { mt: 1, p: 2, textAlign: "center" };

  if (loading) {
    return (
      <Paper sx={{ ...commonPaperSx, ...sx }}>
        <CircularProgress size={24} />
      </Paper>
    );
  }

  if (results.length === 0) {
    return (
      <Paper sx={{ ...commonPaperSx, ...sx }}>
        <Typography variant="body2" color="text.secondary">
          No results found.
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper sx={{ mt: 1, ...sx }}>
      <List>
        {results.map((result) => (
          <ListItem
            key={result.id}
            data-testid="search-result-item"
            button
            onClick={() => onResultClick(result)}
          >
            <ListItemIcon>
              {result.type === "folder" ? <Folder /> : <InsertDriveFile />}
            </ListItemIcon>
            <ListItemText primary={result.name} />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default SearchResults;
